import React, { useEffect, useState, useRef } from "react";
import { generateGroupInviteCodeAsync, getGroupInviteCodeAsync } from "../../../api/chats";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { UserTypes } from "api";
import { setGroupInviteCode2 } from "../../../redux/chats/actions";
import { Const } from "const";
import { Tooltip } from "react-tooltip";
import { Utils } from "helpers/utils";

interface InviteCodeProps {
    chatUserDetails: any;
}

const InviteCode = ({ chatUserDetails }: InviteCodeProps) => {
    const { dispatch, useAppSelector } = useRedux();
    const storeData = createSelector(
        (state) => state.Profile2,
        (state) => ({
            curUserType: state.userType
        })
    );
    const { curUserType } = useAppSelector(storeData);
    const is2s = curUserType === UserTypes.Employee;
    // const [groupInviteCode, setGroupInviteCode] = useState('');
    // console.log('InviceCode.chatUserDetails:', chatUserDetails);
    const fnGetTitle = () => {
        if (!chatUserDetails) return "";
        if (chatUserDetails.contactType == UserTypes.Customer) return "";
        if (chatUserDetails.contactType == UserTypes.Group) {
            return "รหัสห้องแชท ลูกค้า";
        } else if (chatUserDetails.contactType == UserTypes.GroupSupplier) {
            return "รหัสห้องแชท Supplier";
        } else if (chatUserDetails.contactType == UserTypes.Employee) {
            if (chatUserDetails.isSell) {
                return "รหัสเซลล์";
            } else {
                return "";
            }
        }
        return "";
    }

    const [tipCodeCopyOpen, setTipCodeCopyOpen] = useState<boolean>(false);
    const onCopyClick = async () => {
        if (chatUserDetails.inviteCodeExpired) {
            alert('รหัสห้องแชท หมดอายุแล้ว');
        } else {
            if (chatUserDetails.inviteCode) {
                await navigator.clipboard.writeText(chatUserDetails.inviteCode);
                setTipCodeCopyOpen(true);
                setTimeout(() => { setTipCodeCopyOpen(false); }, 1000);
                // alert('copied');
                // fnSetMsg(false, "คัดลอกลงคลิปบอร์ดแล้ว");
            } else {
                // fnSetMsg(true, "ยังไม่มีรหัส, กรุณาสร้างรหัสก่อน");
            }
        }
    }

    const getRootUrl = (): string => {
        const { protocol, host } = window.location;
        return `${protocol}//${host}/`;
    };

    const [tipLinkCopyOpen, setTipLinkCopyOpen] = useState<boolean>(false);

    const onCopyLinkInviteClick = async () => {
        if (chatUserDetails.inviteCodeExpired) {
            alert('รหัสห้องแชท หมดอายุแล้ว');
        } else {
            if (chatUserDetails.inviteCode) {
                const url = `${getRootUrl()}iv/${chatUserDetails.inviteCode}`;
                await navigator.clipboard.writeText(url);
                setTipLinkCopyOpen(true);
                setTimeout(() => { setTipLinkCopyOpen(false); }, 1000);
                // alert('copied');
                // fnSetMsg(false, "คัดลอกลงคลิปบอร์ดแล้ว");
            } else {
                // fnSetMsg(true, "ยังไม่มีรหัส, กรุณาสร้างรหัสก่อน");
                alert('ไม่มีรหัสเชิญ');
            }
        }
    }

    const [isGenCode, setIsGenCode] = useState<boolean>(false);
    const fnGenCodeClick = async () => {
        if (Utils.IsViewAsAlert()) return;

        setIsGenCode(true);
        generateGroupInviteCodeAsync(chatUserDetails.id)
            .then(result => {
                // console.log(result);
                if (result.success) {
                    // fnSetMsg(false, "ประมวลผลสำเร็จ");
                    //setGroupInviteCode(result.data);
                    dispatch(setGroupInviteCode2(result.data));
                    // alert(result.data);
                } else {
                    // fnSetMsg(true, result.message);
                }
                setIsGenCode(false);
            })
            .catch(error => {
                // fnSetMsg(true, (error as Exception).message);
                alert((error as Error).message);
                setIsGenCode(false);
                // console.log(error);
            });
    }

    const capTitle = fnGetTitle();

    useEffect(() => {

    }, [, chatUserDetails]);

    let newTab: Window | null = null;
    // Function to open a URL in a new tab and reuse the same tab for subsequent calls
    function openUrlInSameTab(url: string): void {
        const tabName = "myUniqueTabName"; // Unique name for the tab
        if (!newTab || newTab.closed) {
            // If the tab doesn't exist or is closed, open a new one
            newTab = window.open(url, tabName);
        } else {
            // If the tab is already open, update its location
            newTab.location.href = url;
            newTab.focus();
        }
    }

    const onClickGroupIcon = async () => {
        try {
            if (curUserType === UserTypes.Employee) {
                if (chatUserDetails.companyId) {
                    const erpUrl = Const.ERP_CUSTOMER_PAGE.replaceAll('[CustomerId]', chatUserDetails.companyId);
                    openUrlInSameTab(erpUrl);
                } else {
                    alert('ยังไม่ได้จับคู่บริษัท');
                }
            }
        } catch (e) {
            console.error(e);
            alert((e as any).message);
        }
    }

    // const groups =
    //     chatUserDetails.InviteCode &&
    //     chatUserDetails.InviteCode.length &&
    //     chatUserDetails.InviteCode;

    // console.log('chatUserDetails:', chatUserDetails);

    return (
        <div>
            {chatUserDetails.contactType == UserTypes.Group && (
                <>
                    <div className="d-flex">
                        <div className="flex-grow-1">
                            <h5 className="font-size-11 text-muted text-uppercase room-group-title">{capTitle}</h5>
                        </div>
                        {is2s && (
                            <div className="ms-auto">
                                <span className="badge badge-soft-primary rounded p-1 ml-1 bg-primary hand" onClick={onClickGroupIcon}>ลูกค้ารายตัว</span>
                            </div>
                        )}
                    </div>

                    <div className="d-flex align-items-center">
                        <div className="flex-grow-1 overflow-hidden">
                            <p className="text-truncate mb-0">
                                {chatUserDetails.inviteCodeExpired && (
                                    <span className="text-red mdi mdi-alert-box" title="รหัสของห้องแชทหมดอายุ"></span>
                                )}
                                {chatUserDetails.inviteCode ?? "ยังไม่มี"}
                            </p>
                        </div>

                        {is2s && (
                            <>
                                <div className="ms-auto">
                                    <span className="badge badge-soft-primary rounded p-1 ml-1 bg-primary hand" data-tooltip-id="tipLinkCopy" data-tooltip-content="คัดลอกแล้ว" onClick={onCopyLinkInviteClick}>Link เชิญ</span>
                                    <Tooltip id="tipLinkCopy" isOpen={tipLinkCopyOpen} />
                                </div>
                                &nbsp;
                            </>
                        )}
                        <div className="ms-auto">
                            <span className="badge badge-soft-primary rounded p-1 ml-1 bg-primary hand" data-tooltip-id="tipCodeCopy" data-tooltip-content="คัดลอกแล้ว" onClick={onCopyClick}>คัดลอก</span>
                            <Tooltip id="tipCodeCopy" isOpen={tipCodeCopyOpen} />
                        </div>
                        &nbsp;
                        <div className="ms-auto">
                            <span className="badge badge-soft-primary rounded p-1 ml-1 bg-danger hand" onClick={fnGenCodeClick}>{isGenCode ? 'กำลังสร้าง' : 'สร้างรหัส'}</span>
                        </div>
                    </div>
                </>
            )
            }
        </div>
    );
};

export default InviteCode;